<script lang="ts">
    import { navigate } from "svelte-navigator";
    import { fade } from "svelte/transition";
    import AppleWalker from "../Components/AppleWalker.svelte";
    import type { Route } from "../Model/Route";
    import { routesService } from "../Services";

    export let routes: Route[] = [];

    let windowWidth: number = 0;

    getRoutes();

    async function getRoutes() {
        routes = await routesService.getAllRoutes();
    }

</script>

<style lang="scss">

    .menu {
        height: var(--vh, 100vh);
        background-color: #fff;
        display: flex;
        flex-direction: column;
    }

    .logo-container {
        height: 330px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        background-image: url('/images/menu-background.jpg');
        background-size: 500px auto;
        background-repeat: repeat-x;
        animation-name: logo-container-background;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }

    .manzanita-player {
        width: 150px;
        height: 150px;
    }

    @keyframes logo-container-background {
        0% {
            background-position: 0% calc(100% - 30px);
        }
        100% {
            background-position: -500px calc(100% - 30px);
        }
    }

    .logo-wrapper {
        flex: 1 1 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .logo {
        width: 55%;
        max-width: 200px;
    }

    .routes {
        padding: 1rem 0;
        flex: 1 1 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;

    }

    .route {
        $height: 3rem;

        display: flex;
        color: #fff;
        font-weight: bold;
        text-decoration: none;
        background-color: transparent;
        border: none;

        .number {
            display: block;
            width: $height;
            height: $height;
            line-height: $height;
            text-align: center;
            border-radius: 3px;
            font-size: 2rem;
        }

        .name {
            display: block;
            padding: 0 1rem;
            line-height: $height;
            margin-left: 0.5rem;
            flex: 1 1 0;
            border-radius: 3px;
            font-size: 1.1rem;
        }

        & + .route {
            margin-top: 0.5rem;
        }
    }

    .logos-entities {
        background-color: var(--color-secondary);
        padding: 1rem;
        text-align: center;
        display: flex;
        justify-content: center;

        img {
            flex: 1 1 0;
            max-width: 240px;
        }
    }

    .credits {
        font-size: 0.6rem;
        text-align: center;
        padding: 0.3rem;
    }

</style>

<svelte:window bind:innerWidth={windowWidth} />

<div class="menu view-container" transition:fade>

    <div class="logo-container">

        <div class="logo-wrapper">
            <img class="logo" src="/images/logo.png" alt="">
        </div>
        
        <lottie-player
            class="manzanita-player"
            src="/lotties/mascota_ajuste.json"
            speed="1"
            loop
            autoplay></lottie-player>
        
    </div>

    <div class="view-content routes">
        {#each routes as route, index}
        <button on:click={() => navigate(`/ruta/${route.id}`)} class="route">
            <span class="number" style="background-color: {route.color}">{route.representation}</span>
            <span class="name one-line" style="background-color: {route.color}">{route.name}</span>
        </button>
        {/each}
    </div>

    <div class="logos-entities">
        <img src="/images/logotipos_entidades.svg" alt="">
    </div>
    <div class="credits"><a href="https://routingtales.com/" target="_blank">Made with &#x2764 by RoutingTales &#169;</a></div>
</div>

